import type { ComponentProps } from 'react'
import { MessageCircleQuestion } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import { ActionIconSlot } from '@renderer/components/action-icon-slot'
import { ASK_USER_CARD_THEMES, type AskUserCardVariant } from './theme'

/**
 * The badge standing in for an ask-user card wherever one is announced: the
 * card's own header, the workflow row, the Outbox row, the hover preview, the
 * toast. One glyph for both asks so they read as the same kind of thing, tinted
 * by which one it is. Amber means a question the run is blocked on, blue means
 * optional feedback.
 *
 * `variant` has no default. A surface showing the badge already knows which ask
 * it holds, and a default is how the two colours drift apart.
 *
 * It is an `ActionIconSlot` with the tile tinted, so a row swapping its
 * integration icon for this keeps the same square, unread dot, corner badge and
 * expiry ring as every other row in the list.
 */
export function AskUserBadge({
  variant,
  className,
  ...slotProps
}: { variant: AskUserCardVariant } & Omit<ComponentProps<typeof ActionIconSlot>, 'children' | 'view'>) {
  const theme = ASK_USER_CARD_THEMES[variant]

  return (
    <ActionIconSlot {...slotProps} className={twMerge(theme.badgeSurface, className)}>
      <MessageCircleQuestion className={theme.badgeGlyph} />
    </ActionIconSlot>
  )
}
